import React from 'react';
import { UserCheck, Star } from 'lucide-react';
import { useNavigate } from 'react-router-dom';



export default function CandidateCard({ candidate, color }) {

  const navigate = useNavigate();

  return (
    <div
      className="kanban-card"
      onClick={() => navigate(`/pipeline/${candidate.id}`)}
      style={{
        borderLeft: `4px solid ${color}`
      }}
    >

      <div className="kanban-card-header">

        <div className="kanban-card-title">
          {candidate.full_name ||
   `${candidate.first_name || ''} ${candidate.last_name || ''}`.trim()}
        </div>

        {candidate.favorite && (
          <Star size={14} color="#F59E0B" />
        )}

      </div>

      <div className="kanban-card-sub">
        {candidate.email}
      </div>

      <div className="kanban-card-footer">

        {candidate.source_type && (
          <span className="tag">
            {candidate.source_type}
          </span>
        )}

        {candidate.priority && (
          <span className={`tag priority-${candidate.priority.toLowerCase()}`}>
            {candidate.priority}
          </span>
        )}

      </div>

    </div>
  );
}
  

